import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from './context/ThemeContext';
import { AdminProvider } from './context/AdminContext';
import AuthPage from "./components/pages/auth/AuthPage";
import GoogleCallback from "./components/pages/auth/GoogleCallback";
import HomePage from "./components/pages/home/HomePage";
import ProtectedRoute from "./components/pages/ProtectedRoute";
import ChatPage from "./components/pages/chat/Chatpage";
import UpgradePlan from "./components/pages/upgradePlan/UpgradePlan";
import Pricing from "./components/pages/home/pages/Pricing";
import ContactPage from "./components/pages/home/pages/ContactPage";
import PrivacyPolicy from "./components/pages/home/pages/PrivacyPolicy";
import Checkout from "./components/pages/CheckOut/checkout";
import AdminPanel from "./components/pages/adminPanel/AdminPanel";
import NotFoundPage from "./components/pages/NotFoundPage"; // Import NotFoundPage

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <ThemeProvider>
          <AdminProvider>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/auth/:page?" element={<AuthPage />} />
              <Route path="/auth/google/callback" element={<GoogleCallback />} />
              <Route
                path="/upgrade"
                element={
                  <ProtectedRoute>
                    <UpgradePlan />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/pricing"
                element={
                  <Pricing />
                }
              />
              <Route
                path="/contact"
                element={
                  <ContactPage />
                }
              />
              <Route
                path="/privacy-policy"
                element={<PrivacyPolicy />}
              />
              <Route
                path="/checkout"
                element={
                  <ProtectedRoute>
                    <Checkout />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/chat/:chatId?"
                element={
                  <ProtectedRoute>
                    <ChatPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/*"
                element={
                  <ProtectedRoute>
                    <AdminPanel />
                  </ProtectedRoute>
                }
              />
              {/* Catch-all route for undefined paths */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </AdminProvider>
        </ThemeProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
